/**
 * Management → Public Site Integration。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_public_site_integration。
 * STATSIG.PUBLIC_SITE_INTEGRATION.COPY → PUBLIC_SITE_INTEGRATION_COPY
 *
 * 正在用：打开页面；三个工具的 Copy code。
 * 已不算：View Tool 预览、Contact support、文档链接、旧版 Integration。
 */
export enum MgmtPublicSiteIntegrationEvent {
    /**
     * Copy code。
     * 属性 type=affordability|calculator|rate_search
     */
    COPY = 'PUBLIC_SITE_INTEGRATION_COPY',
}
